export function initializeFaq() {
    const faqToggles = document.querySelectorAll('.toggle-answer');
    if (faqToggles.length === 0) return;

    faqToggles.forEach(button => {
        button.addEventListener('click', function() {
            const icon = this.querySelector('i');
            const answerRow = this.closest('tr').nextElementSibling;

            if (!answerRow) {
                return;
            }

            const isCurrentlyOpen = !answerRow.classList.contains('d-none');

            // Close all other answers
            document.querySelectorAll('.faq-answer').forEach(ar => {
                ar.classList.add('d-none');
                const otherIcon = ar.previousElementSibling.querySelector('.toggle-answer i');
                if (otherIcon) {
                    otherIcon.classList.remove('fa-chevron-up');
                    otherIcon.classList.add('fa-chevron-down');
                }
            });

            // Toggle the current answer if it was closed
            if (!isCurrentlyOpen) {
                answerRow.classList.remove('d-none');
                icon.classList.remove('fa-chevron-down');
                icon.classList.add('fa-chevron-up');
            }
        });
    });
}